import { Component } from '@angular/core';

@Component({
  selector: 'ssg-unauthorized-qualifiers',
  templateUrl: './unauthorized-qualifiers.component.html',
  styleUrls: ['./unauthorized-qualifiers.component.less']
})
export class UnauthorizedQualifiersComponent {
  openRoleAdministrationGuide(event: Event) {
    event.preventDefault();
    window.open('https://library.ukg.com/manage-employee-pay', '_blank');
  }
}
